import type { ReactNode } from 'react';
import { AuthBootstrap } from './AuthBootstrap';
import { ThemeProvider } from './ThemeProvider';

interface AppProvidersProps {
  children: ReactNode;
}

/**
 * Compose all global providers here.
 * AuthBootstrap restores the session (httpOnly refresh cookie) before render.
 */
export function AppProviders({ children }: AppProvidersProps) {
  return (
    <ThemeProvider>
      <AuthBootstrap>{children}</AuthBootstrap>
    </ThemeProvider>
  );
}
